import script from "./MyOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./MyOrders.vue?vue&type=script&setup=true&lang=js"

import "./MyOrders.vue?vue&type=style&index=0&id=ed8b6b7c&lang=scss&scoped=true"

import exportComponent from "D:\\obj\\komanch\\web-company\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed8b6b7c"]])

export default __exports__